import { CacheKeyType, PreviewType } from '../domainObjects/transformType';

export class GetFilteredselcolvalsRequest {
    userId: string;
    orgId: string;
    refineryId: string;
    nodeId: string;
    transformId: string;
    cacheKeyType:CacheKeyType;
    columnName: string;

    constructor(
        userId: string,
        orgId: string,
        refineryId: string,
        nodeId: string,
        transformId: string,
        cacheKeyType:CacheKeyType,
        columnName: string,
        ) {
        this.userId = userId;
        this.orgId = orgId;
        this.refineryId = refineryId;
        this.nodeId = nodeId;
        this.transformId = transformId;
        this.cacheKeyType = cacheKeyType;
        this.columnName = columnName;
    }
}